import http from './api'

const route = 'app/comercial/time4/'

export default {
  dadosEvolucaoTimeSupervisor: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, area, classificacao, linhaProducao) => {
    return http.post(route + 'dadosEvolucaoTimeSupervisor', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      area: area,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
    })
  },

  showDadosTime4Vendas: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, area, classificacao, linhaProducao) => {
    return http.post(route + 'showDadosTime4Vendas', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      area: area,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
    })
  },

  showCoberturaVendedorTime4: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, area, classificacao, linhaProducao) => {
    return http.post(route + 'showCoberturaVendedorTime4', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      area: area,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
    })
  },

  showDetalheCoberturaVendedorTime4: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, area, classificacao, linhaProducao) => {
    return http.post(route + 'showDetalheCoberturaVendedorTime4', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      area: area,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
    })
  },

  showAtigimentoMetaPeriodoTime4: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, area, classificacao, linhaProducao) => {
    return http.post(route + 'showAtigimentoMetaPeriodoTime4', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      area: area,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
    })
  },

  showLocalizacaoTime4: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, area, classificacao, linhaProducao) => {
    return http.post(route + 'showLocalizacaoTime4', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      area: area,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
    })
  },

  showTicketMedioTime4: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, area, classificacao, linhaProducao) => {
    return http.post(route + 'showTicketMedioTime4', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      area: area,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
    })
  },

  showTicketSupervisorxEmpresaTime4: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, area, classificacao, linhaProducao) => {
    return http.post(route + 'showTicketSupervisorxEmpresaTime4', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      area: area,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
    })
  },
}
